module.exports = __webpack_public_path__ + "static/media/robin_0.c6f6eedc.png";